import React from 'react';
import { ZoomMeta } from '../../hooks/useZoomPreview';

interface DashboardImagePreviewProps {
  imageUrl?: string | null;
  fallback: string;
  size: number;
  alt?: string;
  title?: string;
  className?: string;
  meta?: ZoomMeta;
  onImageHover?: (event: React.MouseEvent, url: string, meta?: ZoomMeta) => void;
  onImageMove?: (event: React.MouseEvent, url: string, meta?: ZoomMeta) => void;
  onImageLeave?: () => void;
}

export const DashboardImagePreview: React.FC<DashboardImagePreviewProps> = ({
  imageUrl,
  fallback,
  size,
  alt = '',
  title,
  className,
  meta,
  onImageHover,
  onImageMove,
  onImageLeave,
}) => {
  const classes = ['forge-dashboard-thumb', className].filter(Boolean).join(' ');
  const style = { width: size, height: size } as React.CSSProperties;

  return (
    <div
      className={classes}
      title={title}
      style={style}
      onMouseEnter={
        imageUrl && onImageHover ? (event) => onImageHover(event, imageUrl, meta) : undefined
      }
      onMouseMove={
        imageUrl && onImageMove ? (event) => onImageMove(event, imageUrl, meta) : undefined
      }
      onMouseLeave={imageUrl ? onImageLeave : undefined}
    >
      {imageUrl ? <img src={imageUrl} alt={alt} loading="lazy" /> : <span>{fallback}</span>}
    </div>
  );
};
